
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPendingPRDtGrid extends Serenity.EntityGrid<ReportPendingPRDtRow, any> {
        protected getColumnsKey() { return ReportPendingPRDtColumns.columnsKey; }
        protected getDialogType() { return ReportPendingPRDtDialog; }
        protected getIdProperty() { return ReportPendingPRDtRow.idProperty; }
        protected getInsertPermission() { return ReportPendingPRDtRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportPendingPRDtRow.localTextPrefix; }
        protected getService() { return ReportPendingPRDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        
    }

}